<template>
  <span>
     <slot name="clockOut" v-bind:item="item">
       <v-badge
         :value="badge && (!!item.hasTimeZoneDiscrepancy || !!item.hasShiftTimeZoneDiscrepancy)"
         :left="isMobile()"
         :inline="!badge"
         dot
         :class="{ 'mr-n2': !isMobile() && !badge, 'ml-n2': isMobile() && !badge }"
         color="warning lighten-1"
       >
          <v-tooltip top :disabled="!badge || !(!!item.hasTimeZoneDiscrepancy || !!item.hasShiftTimeZoneDiscrepancy)">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <span v-if="isArray(clockOutTime)">
                  {{ clockOutTime[0] }}
                  <br/>
                  {{ clockOutTime[1] }}
                </span>
                <span v-else class="text-no-wrap">
                  {{ clockOutTime }}
                </span>
              </div>
            </template>
            <span> {{ $t('indicators.differentTimeZone') }} </span>
            <br/>
            <span> {{ $t('indicators.actualDurationDiffers') }} </span>
            <br v-if="item.hasShiftTimeZoneDiscrepancy"/>
            <span v-if="item.hasShiftTimeZoneDiscrepancy">
              {{ $t('indicators.shiftInDifferentTimeZone') }}
            </span>
            <br v-if="item.hasTimeZoneDiscrepancy"/>
            <span v-if="item.hasTimeZoneDiscrepancy">
               {{ $t('indicators.durationAccurateDate', { duration: durationAccurateDate }) }}
            </span>
          </v-tooltip>
        </v-badge>
    </slot>
  </span>
</template>

<script>
import isArray from 'lodash/isArray';

import DateTimeUtil from '@/util/date-time-util';

import displayAdaptable from '@/mixins/displayAdaptable';
import getActualStartOrEndTime from '@/mixins/timepairs/getActualStartOrEndTime';

export default {
  name: 'EndTimeTableCell',

  mixins: [displayAdaptable, getActualStartOrEndTime],

  props: {
    item: {
      type: Object,
      required: true,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    badge: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      stringMinimumWrapLength: 10,
    };
  },

  computed: {
    clockOutTime() {
      const dateTimeString = DateTimeUtil.convertToHumanReadableClockOutTime(
        this.item.clockIn.date,
        getActualStartOrEndTime.methods.getActualEndTime(this.item).date,
      );

      if (dateTimeString.length > this.stringMinimumWrapLength && this.wrap) {
        const dateParts = dateTimeString.split(' ');
        const last = dateParts.pop();
        return [dateParts.join(' '), last];
      }
      return dateTimeString;
    },

    durationAccurateDate() {
      return DateTimeUtil.convertToHumanReadableDateTime(getActualStartOrEndTime.methods.getActualEndTime(this.item)
      .durationAccurateDate);
    },
  },

  methods: {
    isArray(val) {
      return isArray(val);
    },
  },
};
</script>
